import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Sale02 = function Sale02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M9 9h.01M15 15h.01M16 8l-8 8M7.3338 3.8187a3.832 3.832 0 0 0 2.1807-.9033c1.4322-1.2205 3.5388-1.2205 4.971 0a3.832 3.832 0 0 0 2.1807.9033c1.8759.1497 3.3654 1.6392 3.5151 3.515a3.832 3.832 0 0 0 .9033 2.1808c1.2205 1.4322 1.2205 3.5388 0 4.971a3.832 3.832 0 0 0-.9033 2.1807c-.1497 1.8759-1.6392 3.3654-3.5151 3.5151a3.832 3.832 0 0 0-2.1807.9033c-1.4322 1.2205-3.5388 1.2205-4.971 0a3.832 3.832 0 0 0-2.1807-.9033c-1.8759-.1497-3.3654-1.6392-3.5151-3.5151a3.832 3.832 0 0 0-.9033-2.1807c-1.2205-1.4322-1.2205-3.5388 0-4.971a3.832 3.832 0 0 0 .9033-2.1807c.1497-1.8759 1.6392-3.3654 3.515-3.5151M9.5 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m6 6a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 15.5 15"
    })
  }));
};
export default Sale02;